import ColorPicker from "@stimulus-components/color-picker"

export default class extends ColorPicker {
  connect() {
    super.connect()
    this.syncSwatch()
  }

  onSave(color) {
    super.onSave(color)
    this.syncSwatch()
  }

  syncSwatch() {
    this.renderSwatch(this.inputTarget.value)
    requestAnimationFrame(() => this.renderSwatch(this.inputTarget.value))
  }

  renderSwatch(value) {
    const hasColor = value && value.trim() !== ""
    const swatchButton = this.buttonTarget.querySelector(".pcr-button") || this.buttonTarget

    this.buttonTarget.dataset.colorPickerEmpty = hasColor ? "false" : "true"
    swatchButton.style.backgroundImage = hasColor ? "none" : ""
    swatchButton.style.backgroundColor = hasColor ? value : "transparent"
    this.buttonTarget.title = hasColor ? `Color: ${value}` : "Choose color"
  }
}
